import { DelegationEntity } from '../../Entities/Delegation.Entity';
import { SmartDBApi } from '../index.exports';

export class DelegationApi extends SmartDBApi {
    protected static _Entity = DelegationEntity;

    // #region api

   
    // #endregion api
}
